<div class="site-permission-editor-container d-flex flex-wrap">
  <div class="checkbox-wrapper w-25" *ngIf="allSites().length > 1">
    <mat-checkbox [checked]="allSelected()" (change)="selectAllSite($event)"
      >Select All
    </mat-checkbox>
  </div>
  <div
    class="checkbox-wrapper pr-3 w-25"
    *ngFor="let site of allSites(); let ind = index"
  >
    <div
      class="checkbox-wrapper-inner d-inline-flex flex-nowrap overflow-hidden w-auto"
    >
      <mat-checkbox
        class="label-truncatable text-ellipsis overflow-hidden min-width-0"
        [checked]="permittedSiteIds().includes(site.siteId)"
        [title]="site.siteName"
        (change)="toggleSite(site.siteId, $event.checked)"
        [disabled]="false"
        site.isPermitted
        >{{ site.siteName }}
      </mat-checkbox>
      <mat-icon
        class="flex-shrink-0 ml-1"
        *ngIf="site.siteId === defaultSite()"
        color="primary"
        title="Default Site"
        >star</mat-icon
      >
    </div>
  </div>
</div>
